module.exports = __webpack_public_path__ + "static/sportsconnect_about-us-a7ba4ae0d829244c8282cc8c0a59186b.jpg";